import { render, staticRenderFns } from "./HomeMobilePayment.vue?vue&type=template&id=076835d5&scoped=true&"
var script = {}
import style0 from "./HomeMobilePayment.vue?vue&type=style&index=0&id=076835d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076835d5",
  null
  
)

export default component.exports